// source: src/common/canvas/canvas.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var src_common_canvas_canvas_tile_pb = require('../../../src/common/canvas/canvas_tile_pb.js');
goog.object.extend(proto, src_common_canvas_canvas_tile_pb);
goog.exportSymbol('proto.loupe.common.canvas.Canvas', null, global);
goog.exportSymbol('proto.loupe.common.canvas.CanvasLayout', null, global);
goog.exportSymbol('proto.loupe.common.canvas.CanvasStandardParams', null, global);
goog.exportSymbol('proto.loupe.common.canvas.CanvasStatus', null, global);
goog.exportSymbol('proto.loupe.common.canvas.CanvasTenantStandardParams', null, global);
goog.exportSymbol('proto.loupe.common.canvas.CanvasTileLayout', null, global);
goog.exportSymbol('proto.loupe.common.canvas.Layout', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.Canvas = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.canvas.Canvas.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.canvas.Canvas, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.Canvas.displayName = 'proto.loupe.common.canvas.Canvas';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.CanvasLayout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.canvas.CanvasLayout.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.canvas.CanvasLayout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.CanvasLayout.displayName = 'proto.loupe.common.canvas.CanvasLayout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.CanvasTileLayout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.canvas.CanvasTileLayout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.CanvasTileLayout.displayName = 'proto.loupe.common.canvas.CanvasTileLayout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.Layout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.canvas.Layout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.Layout.displayName = 'proto.loupe.common.canvas.Layout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.CanvasStandardParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.canvas.CanvasStandardParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.CanvasStandardParams.displayName = 'proto.loupe.common.canvas.CanvasStandardParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.CanvasTenantStandardParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.canvas.CanvasTenantStandardParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.CanvasTenantStandardParams.displayName = 'proto.loupe.common.canvas.CanvasTenantStandardParams';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.canvas.Canvas.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.Canvas.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.Canvas.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.Canvas} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.Canvas.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    key: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    tileContainersList: jspb.Message.toObjectList(msg.getTileContainersList(),
    src_common_canvas_canvas_tile_pb.CanvasTile.toObject, includeInstance),
    canvasLayout: (f = msg.getCanvasLayout()) && proto.loupe.common.canvas.CanvasLayout.toObject(includeInstance, f),
    canvasStandardParams: (f = msg.getCanvasStandardParams()) && proto.loupe.common.canvas.CanvasStandardParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.Canvas}
 */
proto.loupe.common.canvas.Canvas.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.Canvas;
  return proto.loupe.common.canvas.Canvas.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.Canvas} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.Canvas}
 */
proto.loupe.common.canvas.Canvas.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = new src_common_canvas_canvas_tile_pb.CanvasTile;
      reader.readMessage(value,src_common_canvas_canvas_tile_pb.CanvasTile.deserializeBinaryFromReader);
      msg.addTileContainers(value);
      break;
    case 8:
      var value = new proto.loupe.common.canvas.CanvasLayout;
      reader.readMessage(value,proto.loupe.common.canvas.CanvasLayout.deserializeBinaryFromReader);
      msg.setCanvasLayout(value);
      break;
    case 9:
      var value = new proto.loupe.common.canvas.CanvasStandardParams;
      reader.readMessage(value,proto.loupe.common.canvas.CanvasStandardParams.deserializeBinaryFromReader);
      msg.setCanvasStandardParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.Canvas.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.Canvas.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.Canvas} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.Canvas.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTileContainersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      src_common_canvas_canvas_tile_pb.CanvasTile.serializeBinaryToWriter
    );
  }
  f = message.getCanvasLayout();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.loupe.common.canvas.CanvasLayout.serializeBinaryToWriter
    );
  }
  f = message.getCanvasStandardParams();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.loupe.common.canvas.CanvasStandardParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.loupe.common.canvas.Canvas.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.loupe.common.canvas.Canvas.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_id = 3;
 * @return {string}
 */
proto.loupe.common.canvas.Canvas.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string key = 4;
 * @return {string}
 */
proto.loupe.common.canvas.Canvas.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.canvas.Canvas.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
*/
proto.loupe.common.canvas.Canvas.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.Canvas.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.canvas.Canvas.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
*/
proto.loupe.common.canvas.Canvas.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.Canvas.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated CanvasTile tile_containers = 7;
 * @return {!Array<!proto.loupe.common.canvas.CanvasTile>}
 */
proto.loupe.common.canvas.Canvas.prototype.getTileContainersList = function() {
  return /** @type{!Array<!proto.loupe.common.canvas.CanvasTile>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_canvas_canvas_tile_pb.CanvasTile, 7));
};


/**
 * @param {!Array<!proto.loupe.common.canvas.CanvasTile>} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
*/
proto.loupe.common.canvas.Canvas.prototype.setTileContainersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.loupe.common.canvas.CanvasTile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.canvas.CanvasTile}
 */
proto.loupe.common.canvas.Canvas.prototype.addTileContainers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.loupe.common.canvas.CanvasTile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.clearTileContainersList = function() {
  return this.setTileContainersList([]);
};


/**
 * optional CanvasLayout canvas_layout = 8;
 * @return {?proto.loupe.common.canvas.CanvasLayout}
 */
proto.loupe.common.canvas.Canvas.prototype.getCanvasLayout = function() {
  return /** @type{?proto.loupe.common.canvas.CanvasLayout} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.canvas.CanvasLayout, 8));
};


/**
 * @param {?proto.loupe.common.canvas.CanvasLayout|undefined} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
*/
proto.loupe.common.canvas.Canvas.prototype.setCanvasLayout = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.clearCanvasLayout = function() {
  return this.setCanvasLayout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.Canvas.prototype.hasCanvasLayout = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional CanvasStandardParams canvas_standard_params = 9;
 * @return {?proto.loupe.common.canvas.CanvasStandardParams}
 */
proto.loupe.common.canvas.Canvas.prototype.getCanvasStandardParams = function() {
  return /** @type{?proto.loupe.common.canvas.CanvasStandardParams} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.canvas.CanvasStandardParams, 9));
};


/**
 * @param {?proto.loupe.common.canvas.CanvasStandardParams|undefined} value
 * @return {!proto.loupe.common.canvas.Canvas} returns this
*/
proto.loupe.common.canvas.Canvas.prototype.setCanvasStandardParams = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.Canvas} returns this
 */
proto.loupe.common.canvas.Canvas.prototype.clearCanvasStandardParams = function() {
  return this.setCanvasStandardParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.Canvas.prototype.hasCanvasStandardParams = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.canvas.CanvasLayout.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.CanvasLayout.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.CanvasLayout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.CanvasLayout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasLayout.toObject = function(includeInstance, msg) {
  var f, obj = {
    canvasTilesList: jspb.Message.toObjectList(msg.getCanvasTilesList(),
    proto.loupe.common.canvas.CanvasTileLayout.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.CanvasLayout}
 */
proto.loupe.common.canvas.CanvasLayout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.CanvasLayout;
  return proto.loupe.common.canvas.CanvasLayout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.CanvasLayout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.CanvasLayout}
 */
proto.loupe.common.canvas.CanvasLayout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.loupe.common.canvas.CanvasTileLayout;
      reader.readMessage(value,proto.loupe.common.canvas.CanvasTileLayout.deserializeBinaryFromReader);
      msg.addCanvasTiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.CanvasLayout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.CanvasLayout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.CanvasLayout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasLayout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanvasTilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.loupe.common.canvas.CanvasTileLayout.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CanvasTileLayout canvas_tiles = 1;
 * @return {!Array<!proto.loupe.common.canvas.CanvasTileLayout>}
 */
proto.loupe.common.canvas.CanvasLayout.prototype.getCanvasTilesList = function() {
  return /** @type{!Array<!proto.loupe.common.canvas.CanvasTileLayout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.common.canvas.CanvasTileLayout, 1));
};


/**
 * @param {!Array<!proto.loupe.common.canvas.CanvasTileLayout>} value
 * @return {!proto.loupe.common.canvas.CanvasLayout} returns this
*/
proto.loupe.common.canvas.CanvasLayout.prototype.setCanvasTilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loupe.common.canvas.CanvasTileLayout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.canvas.CanvasTileLayout}
 */
proto.loupe.common.canvas.CanvasLayout.prototype.addCanvasTiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loupe.common.canvas.CanvasTileLayout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.canvas.CanvasLayout} returns this
 */
proto.loupe.common.canvas.CanvasLayout.prototype.clearCanvasTilesList = function() {
  return this.setCanvasTilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.CanvasTileLayout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.CanvasTileLayout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTileLayout.toObject = function(includeInstance, msg) {
  var f, obj = {
    tileKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    layout: (f = msg.getLayout()) && proto.loupe.common.canvas.Layout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.CanvasTileLayout}
 */
proto.loupe.common.canvas.CanvasTileLayout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.CanvasTileLayout;
  return proto.loupe.common.canvas.CanvasTileLayout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.CanvasTileLayout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.CanvasTileLayout}
 */
proto.loupe.common.canvas.CanvasTileLayout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTileKey(value);
      break;
    case 2:
      var value = new proto.loupe.common.canvas.Layout;
      reader.readMessage(value,proto.loupe.common.canvas.Layout.deserializeBinaryFromReader);
      msg.setLayout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.CanvasTileLayout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.CanvasTileLayout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTileLayout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTileKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLayout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.loupe.common.canvas.Layout.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tile_key = 1;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.getTileKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTileLayout} returns this
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.setTileKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Layout layout = 2;
 * @return {?proto.loupe.common.canvas.Layout}
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.getLayout = function() {
  return /** @type{?proto.loupe.common.canvas.Layout} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.canvas.Layout, 2));
};


/**
 * @param {?proto.loupe.common.canvas.Layout|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasTileLayout} returns this
*/
proto.loupe.common.canvas.CanvasTileLayout.prototype.setLayout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasTileLayout} returns this
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.clearLayout = function() {
  return this.setLayout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasTileLayout.prototype.hasLayout = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.Layout.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.Layout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.Layout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.Layout.toObject = function(includeInstance, msg) {
  var f, obj = {
    rowIdx: jspb.Message.getFieldWithDefault(msg, 1, 0),
    colIdx: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rowSpan: jspb.Message.getFieldWithDefault(msg, 3, 0),
    colSpan: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.Layout}
 */
proto.loupe.common.canvas.Layout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.Layout;
  return proto.loupe.common.canvas.Layout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.Layout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.Layout}
 */
proto.loupe.common.canvas.Layout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRowIdx(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setColIdx(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRowSpan(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setColSpan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.Layout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.Layout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.Layout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.Layout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowIdx();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getColIdx();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRowSpan();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getColSpan();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 row_idx = 1;
 * @return {number}
 */
proto.loupe.common.canvas.Layout.prototype.getRowIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.Layout} returns this
 */
proto.loupe.common.canvas.Layout.prototype.setRowIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 col_idx = 2;
 * @return {number}
 */
proto.loupe.common.canvas.Layout.prototype.getColIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.Layout} returns this
 */
proto.loupe.common.canvas.Layout.prototype.setColIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 row_span = 3;
 * @return {number}
 */
proto.loupe.common.canvas.Layout.prototype.getRowSpan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.Layout} returns this
 */
proto.loupe.common.canvas.Layout.prototype.setRowSpan = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 col_span = 4;
 * @return {number}
 */
proto.loupe.common.canvas.Layout.prototype.getColSpan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.Layout} returns this
 */
proto.loupe.common.canvas.Layout.prototype.setColSpan = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.CanvasStandardParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.CanvasStandardParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasStandardParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantStandardParams: (f = msg.getTenantStandardParams()) && proto.loupe.common.canvas.CanvasTenantStandardParams.toObject(includeInstance, f),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.CanvasStandardParams}
 */
proto.loupe.common.canvas.CanvasStandardParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.CanvasStandardParams;
  return proto.loupe.common.canvas.CanvasStandardParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.CanvasStandardParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.CanvasStandardParams}
 */
proto.loupe.common.canvas.CanvasStandardParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.loupe.common.canvas.CanvasTenantStandardParams;
      reader.readMessage(value,proto.loupe.common.canvas.CanvasTenantStandardParams.deserializeBinaryFromReader);
      msg.setTenantStandardParams(value);
      break;
    case 2:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.CanvasStandardParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.CanvasStandardParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasStandardParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantStandardParams();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.loupe.common.canvas.CanvasTenantStandardParams.serializeBinaryToWriter
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CanvasTenantStandardParams tenant_standard_params = 1;
 * @return {?proto.loupe.common.canvas.CanvasTenantStandardParams}
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.getTenantStandardParams = function() {
  return /** @type{?proto.loupe.common.canvas.CanvasTenantStandardParams} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.canvas.CanvasTenantStandardParams, 1));
};


/**
 * @param {?proto.loupe.common.canvas.CanvasTenantStandardParams|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasStandardParams} returns this
*/
proto.loupe.common.canvas.CanvasStandardParams.prototype.setTenantStandardParams = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasStandardParams} returns this
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.clearTenantStandardParams = function() {
  return this.setTenantStandardParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.hasTenantStandardParams = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, string> metadata = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.loupe.common.canvas.CanvasStandardParams} returns this
 */
proto.loupe.common.canvas.CanvasStandardParams.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.CanvasTenantStandardParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.CanvasTenantStandardParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    fiscalYearStartMonth: jspb.Message.getFieldWithDefault(msg, 1, 0),
    salesPeriodLength: jspb.Message.getFieldWithDefault(msg, 2, 0),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tzOffset: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.CanvasTenantStandardParams}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.CanvasTenantStandardParams;
  return proto.loupe.common.canvas.CanvasTenantStandardParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.CanvasTenantStandardParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.CanvasTenantStandardParams}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFiscalYearStartMonth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSalesPeriodLength(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTzOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.CanvasTenantStandardParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.CanvasTenantStandardParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFiscalYearStartMonth();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSalesPeriodLength();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTzOffset();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 fiscal_year_start_month = 1;
 * @return {number}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.getFiscalYearStartMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.CanvasTenantStandardParams} returns this
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.setFiscalYearStartMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 sales_period_length = 2;
 * @return {number}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.getSalesPeriodLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.CanvasTenantStandardParams} returns this
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.setSalesPeriodLength = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string currency_code = 3;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTenantStandardParams} returns this
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 tz_offset = 4;
 * @return {number}
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.getTzOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.canvas.CanvasTenantStandardParams} returns this
 */
proto.loupe.common.canvas.CanvasTenantStandardParams.prototype.setTzOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.loupe.common.canvas.CanvasStatus = {
  ACTIVE: 0,
  INACTIVE: 1
};

goog.object.extend(exports, proto.loupe.common.canvas);
